import { render, staticRenderFns } from "./ViewMethodAssignmentOfInterventions.vue?vue&type=template&id=3bf3cd8a"
import script from "./ViewMethodAssignmentOfInterventions.vue?vue&type=script&lang=js"
export * from "./ViewMethodAssignmentOfInterventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports